import type { BuildDomain } from '../enums/build/build-domain';
import { BuildType } from '../enums/build/build-type';

export function getGtmId(buildType: BuildType): string {
  switch (buildType) {
    case BuildType.DAVID_LLOYD_BELGIUM:
      return process.env.GATSBY_GTM_ID_BE!;
    case BuildType.DAVID_LLOYD_GERMANY:
      return process.env.GATSBY_GTM_ID_DE!;
    case BuildType.DAVID_LLOYD_SPAIN:
      return process.env.GATSBY_GTM_ID_ES!;
    case BuildType.DAVID_LLOYD_FRANCE:
      return process.env.GATSBY_GTM_ID_FR!;
    case BuildType.DAVID_LLOYD_IRELAND:
      return process.env.GATSBY_GTM_ID_IE!;
    case BuildType.DAVID_LLOYD_ITALY:
      return process.env.GATSBY_GTM_ID_IT!;
    case BuildType.DAVID_LLOYD_NETHERLANDS:
      return process.env.GATSBY_GTM_ID_NL!;
    case BuildType.HARBOUR:
      return process.env.GATSBY_GTM_ID_HARBOUR!;
    case BuildType.DAVID_LLOYD_UK:
      return process.env.GATSBY_GTM_ID_UK!;
    case BuildType.MERIDIAN:
      return process.env.GATSBY_GTM_ID_MERIDIAN!;
    case BuildType.DAVID_LLOYD_SWITZERLAND:
      return process.env.GATSBY_GTM_ID_CH!;
    case BuildType.TOGETHER_FOUNDATION:
      return process.env.GATSBY_GTM_ID_TOGETHER_FOUNDATION!;
    default:
      throw new Error(`No GTM container for buildType ${buildType as string}`);
  }
}

export function getSiteBaseUrl(buildType: BuildType): string {
  switch (buildType) {
    case BuildType.DAVID_LLOYD_BELGIUM:
      return process.env.GATSBY_SITE_BASE_URL_BELGIUM!;
    case BuildType.DAVID_LLOYD_FRANCE:
      return process.env.GATSBY_SITE_BASE_URL_FRANCE!;
    case BuildType.DAVID_LLOYD_GERMANY:
      return process.env.GATSBY_SITE_BASE_URL_GERMANY!;
    case BuildType.HARBOUR:
      return process.env.GATSBY_SITE_BASE_URL_HARBOUR!;
    case BuildType.DAVID_LLOYD_IRELAND:
      return process.env.GATSBY_SITE_BASE_URL_IRELAND!;
    case BuildType.DAVID_LLOYD_ITALY:
      return process.env.GATSBY_SITE_BASE_URL_ITALY!;
    case BuildType.DAVID_LLOYD_NETHERLANDS:
      return process.env.GATSBY_SITE_BASE_URL_NETHERLANDS!;
    case BuildType.DAVID_LLOYD_SPAIN:
      return process.env.GATSBY_SITE_BASE_URL_SPAIN!;
    case BuildType.MERIDIAN:
      return process.env.GATSBY_SITE_BASE_URL_MERIDIAN!;
    case BuildType.DAVID_LLOYD_SWITZERLAND:
      return process.env.GATSBY_SITE_BASE_URL_SWITZERLAND!;
    case BuildType.DAVID_LLOYD_UK:
      return process.env.GATSBY_SITE_BASE_URL_UK!;
    case BuildType.TOGETHER_FOUNDATION:
      return process.env.GATSBY_SITE_BASE_URL_TOGETHER_FOUNDATION!;
  }
}

export function getCloudinaryCName(): string {
  return process.env.GATSBY_CLOUDINARY_CNAME!;
}

export function getBynderDomain(): string {
  return process.env.GATSBY_BYNDER_DOMAIN!;
}

export function getBynderCName(): string {
  return process.env.GATSBY_BYNDER_CNAME!;
}

export function getBuildDomain(): BuildDomain {
  return process.env.BUILD_DOMAIN as BuildDomain;
}

export function getPublicEncryptionKey(): object {
  return JSON.parse(process.env.GATSBY_PUBLIC_ENCRYPTION_KEY!) as object;
}

type PuzzelConfig = {
  customerKey: string;
  configId: string;
};

export function getPuzzelConfig(): PuzzelConfig {
  return {
    customerKey: process.env.GATSBY_PUZZEL_CUSTOMER_KEY!,
    configId: process.env.GATSBY_PUZZEL_CONFIG_ID!,
  };
}

export function getTawkUrl(buildType: BuildType, siteId: string): string {
  switch (buildType) {
    case BuildType.DAVID_LLOYD_BELGIUM: {
      const antwerpSiteId = '106';
      return siteId === antwerpSiteId
        ? process.env.GATSBY_TAWK_URL_ANTWERP!
        : process.env.GATSBY_TAWK_URL_BRUSSELS!;
    }
    case BuildType.DAVID_LLOYD_FRANCE:
      return process.env.GATSBY_TAWK_URL_FRANCE!;
    case BuildType.DAVID_LLOYD_GERMANY:
      return process.env.GATSBY_TAWK_URL_GERMANY!;
    case BuildType.HARBOUR:
      return process.env.GATSBY_TAWK_URL_HARBOUR!;
    case BuildType.DAVID_LLOYD_IRELAND:
      return process.env.GATSBY_TAWK_URL_IRELAND!;
    case BuildType.DAVID_LLOYD_ITALY:
      return process.env.GATSBY_TAWK_URL_ITALY!;
    case BuildType.DAVID_LLOYD_NETHERLANDS:
      return process.env.GATSBY_TAWK_URL_NETHERLANDS!;
    case BuildType.DAVID_LLOYD_SPAIN:
      return process.env.GATSBY_TAWK_URL_SPAIN!;
    case BuildType.MERIDIAN:
      return process.env.GATSBY_TAWK_URL_MERIDIAN!;
    case BuildType.DAVID_LLOYD_SWITZERLAND:
      return process.env.GATSBY_TAWK_URL_SWITZERLAND!;
    default:
      return process.env.GATSBY_TAWK_URL_UK!;
  }
}

export function getABBYChatBaseUrl(buildType: BuildType): string {
  switch (buildType) {
    case BuildType.DAVID_LLOYD_SPAIN:
      return process.env.GATSBY_ABBY_CHAT_IFRAME_URL_SPAIN!;
    case BuildType.DAVID_LLOYD_NETHERLANDS:
      return process.env.GATSBY_ABBY_CHAT_IFRAME_URL_NETHERLANDS!;
    case BuildType.DAVID_LLOYD_BELGIUM:
    case BuildType.DAVID_LLOYD_FRANCE:
    case BuildType.DAVID_LLOYD_GERMANY:
    case BuildType.HARBOUR:
    case BuildType.DAVID_LLOYD_IRELAND:
    case BuildType.DAVID_LLOYD_ITALY:
    case BuildType.MERIDIAN:
    case BuildType.DAVID_LLOYD_SWITZERLAND:
    case BuildType.DAVID_LLOYD_UK:
    case BuildType.TOGETHER_FOUNDATION:
      return process.env.GATSBY_ABBY_CHAT_IFRAME_URL_UK!;
  }
}

export function getYousignIsSandbox(): boolean {
  return process.env.GATSBY_YOUSIGN_IS_SANDBOX === 'true';
}
